import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h2`
  color: #FF7C24;
  font-size: 20px;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  margin: 1rem 0 0.5rem;
  color: #232830;
`;

const StatText = styled.p`
  font-size: 16px;
  margin: 0.25rem 0;
  color: #232830;
`;

export default function ActivationCard({ practiceSessions = [] }) {
  // Web sessions (channel = "1" or "web")
  const webSessions = practiceSessions.filter(p =>
    p.channel && (p.channel.toString().toLowerCase() === '1' || p.channel.toLowerCase() === 'web')
  );

  // iOS sessions (no channel or empty string)
  const iosSessions = practiceSessions.filter(p => !p.channel || p.channel.trim() === '');

  // Web counts
  const webMagicMoment = webSessions.filter(p => p.lessonid === 'magic-moment-1.0').length;
  const webActivation = webSessions.filter(p => p.lessonid === '1.0').length;
  const webPractice = webSessions.filter(p => !['magic-moment-1.0', '1.0', '0.3postpracticefeedback'].includes(p.lessonid)).length;
  const webFeedback = webSessions.filter(p => p.lessonid === '0.3postpracticefeedback').length;

  // iOS counts
  const iosPreActivation = iosSessions.filter(p => p.lessonid === '0.1').length;
  const iosActivation = iosSessions.filter(p => p.lessonid === '1.0').length;
  const iosPractice = iosSessions.filter(p => !['0.1', '1.0', '0.3postpracticefeedback'].includes(p.lessonid)).length;
  const iosFeedback = iosSessions.filter(p => p.lessonid === '0.3postpracticefeedback').length;

  return (
    <Card>
      <Title>Activation Overview</Title>

      <SectionTitle>Website</SectionTitle>
      <StatText>Count - Magic Moment: {webMagicMoment}</StatText>
      <StatText>Count - Activation Lesson: {webActivation}</StatText>
      <StatText>Count - Practice Sessions: {webPractice}</StatText>
      <StatText>Post-Session Feedback: {webFeedback}</StatText>

      <SectionTitle>iOS</SectionTitle>
      <StatText>Count  - Pre-Activation Lessons: {iosPreActivation}</StatText>
      <StatText>Count - Activation Lesson: {iosActivation}</StatText>
      <StatText>Count - Practice Sessions: {iosPractice}</StatText>
      <StatText>Count - Post-Session Feedback: {iosFeedback}</StatText>
    </Card>
  );
}
